import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Usuarios from "./pages/Usuarios";
import Configuracoes from "./pages/Configuracoes";
import Financeiro from "./pages/Financeiro";
import Layout from "./components/Layout";

import Pedidos from "./pages/Pedidos";
import PedidoNovo from "./pages/PedidoNovo";
import PedidoDetalhe from "./pages/PedidoDetalhe";

import TabelaPreco from "./pages/TabelaPreco";
import Comissao from "./pages/Comissao";

export default function RoutesApp() {

  // 🔥 LÓGICA DE AUTENTICAÇÃO (MANTIDA)
  const token = localStorage.getItem("token");
  const refreshToken = localStorage.getItem("refreshToken");

  const isAuthenticated = token || refreshToken;

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const Private = ({ children }) => {
    return isAuthenticated ? (
      <Layout>
        {React.cloneElement(children, { onLogout: handleLogout })}
      </Layout>
    ) : (
      <Navigate to="/" />
    );
  };

  return (
    <Routes>

      <Route path="/" element={<Login />} />

      <Route
        path="/dashboard"
        element={
          <Private>
            <Dashboard />
          </Private>
        }
      />

      <Route
        path="/financeiro"
        element={
          <Private>
            <Financeiro />
          </Private>
        }
      />

      <Route
        path="/comissao"
        element={
          <Private>
            <Comissao />
          </Private>
        }
      />

      {/* 🔹 NOVA ROTA TABELA DE PREÇO */}
      <Route
        path="/tabela-preco"
        element={
          <Private>
            <TabelaPreco />
          </Private>
        }
      />

      <Route
        path="/usuarios"
        element={
          <Private>
            <Usuarios />
          </Private>
        }
      />

      <Route
        path="/configuracoes"
        element={
          <Private>
            <Configuracoes />
          </Private>
        }
      />

      <Route
        path="/pedidos"
        element={
          <Private>
            <Pedidos />
          </Private>
        }
      />

      <Route
        path="/pedidos/novo"
        element={
          <Private>
            <PedidoNovo />
          </Private>
        }
      />

      <Route
        path="/pedidos/:id"
        element={
          <Private>
            <PedidoDetalhe />
          </Private>
        }
      />

      <Route path="*" element={<Navigate to="/" />} />

    </Routes>
  );
}
